import { useEffect, useState } from "react";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { Singleton } from "../../../../../core/services/Singleton";
import usePaginator from "../../../../theme/Component/usePaginator";
import { toast } from "react-toastify";
import { ListMenu } from "../../../../theme/Component/ListMenu";
import { BasicPage } from "../../../../theme/Component/BasicPage";
import { BasicButton } from "../../../../theme/Component/BasicButton";
import { BasicTable } from "../../../../theme/Component/BasicTable";
import { Modal } from "../../../../theme/Component/Modal";
import { ModalConfirm } from "../../../../theme/Component/ModalConfirm";
import { _AnnuallyPayrollFactor, _FactorsList, _PayrollToPayroll, _TaxReporting } from "../../../../../core/services/dataBean/EntityCatalogVdos";
import { AccountantYear } from "../../../GestionTH/EmployeeContract/ProductionPlan/AccountantYear";
import { InfoForTaxCertificateEditor } from "../../InfoForTaxCertificate/InfoForTaxCertificateEditor";
import { ElectronicPayrollCatalogSelect } from "../ElectronicPayrollCatalogSelect";
import { InfoForTaxReportingCatalogSelect } from "../InfoForTaxReportingCatalogSelect";
import { _single } from "../../../../../core/services/dataBean/EntityCatalog";
import { ExportXLSL } from "../../../../theme/Component/ExportXLSX";
import useModal, { MODAL_SM } from "../../../../theme/Component/hooks/useModal";
import { DropDown } from "../../../../theme/Component/DropDown";
import { ElectronicPayrollEditor } from "../../ElectronicPayroll/ElectronicPayrollEditor";



export const FactorsList = () => {

    const factor = useDataBean(_FactorsList);
    const Annually = useDataBean(_AnnuallyPayrollFactor);
    const payroll = useDataBean(_PayrollToPayroll);
    const TaxReporting = useDataBean(_TaxReporting);
    const paginador = usePaginator();
    const [regexStr, setregexStr] = useState<any>(null)
    const [Year, setYear] = useState<any>(_single.getCurrenYear())
    const single = Singleton.getInstance();
    const [lista, setLista] = useState<any>([]);
    const [Account, setAccount] = useState<number>(null)
    const [modaldefinir, setModaldefinir] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modaldef, setModaldef] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalexo, setModalexo] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const modalDownload = useModal("Reporte", MODAL_SM);
    const [listaAll, setListaAll] = useState<any>([]);

    useEffect(() => {
        getLista();
    }, [Year, paginador.page])

    const getLista = () => {

        factor.instance.getFactorsList(Year, regexStr, paginador.page, 15).then(
            (resp: any) => {
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * (15));
                    paginador.setRegiPerPage(15)
                    setLista(resp.List)

                }
            }
        )

    }
    const getListaAll = () => {
        factor.instance.getFactorsList(Year, regexStr, 1, 15 * paginador.pages).then(
            (resp: any) => {
                if (resp) {
                    console.log(resp)
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * (15));
                    paginador.setRegiPerPage(15)
                    setListaAll(resp.List);
                }
            }
        )
    }
    const create = () => {
        factor.setBean({

        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        // factor.instance.deleteAirLine(factor.bean.IDAirLine).then(
        //     (resp: any) => {
        //         getLista();
        //         setModalC({ ...modalC, "view": false });
        //     }
        // )
    }
    const editaItem = () => {
        //console.log(entailment.bean);
        factor.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const addAnnuallyPayrollFactor = () => {

        if (!Annually.bean.IDInfoForTaxCertificate) {
            toast.warning("Debe seleccionar un Concepto de Certificado.");
            return;
        }
        Annually.instance.addAnnuallyPayrollFactor(factor.bean.IDPayrollFactor, Year, Annually.bean.IDInfoForTaxCertificate).then(
            (resp: any) => {
                getLista();
                setModaldefinir({ ...modaldefinir, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const setElectronicPayrollToPayrollFactor = () => {
        if (!payroll.bean.IDElectronicPayroll) {
            toast.warning("Debe seleccionar un Concepto de Nómina Electrónica.");
            return;
        }
        payroll.instance.setElectronicPayrollToPayrollFactor(factor.bean.IDPayrollFactor, payroll.bean.IDElectronicPayroll).then(
            (resp: any) => {
                getLista();
                setModaldef({ ...modaldef, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const setInfoForTaxReportingToPayrollFactor = () => {
        if (!TaxReporting.bean.IDInfoForTaxReporting) {
            toast.warning("Debe seleccionar un Concepto de Nómina Electrónica.");
            return;
        }
        TaxReporting.instance.setInfoForTaxReportingToPayrollFactor(factor.bean.IDPayrollFactor, TaxReporting.bean.IDInfoForTaxReporting).then(
            (resp: any) => {
                getLista();
                setModalexo({ ...modalexo, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const actionsDropDown = [
        { id: 1, name: 'Descargar Reporte', permiso: null, activo: true },

    ];
    const buttons = () => {
        return (
            <div className="row">
                <div className="col-md-12">
                    <DropDown lista={actionsDropDown} eventClick={(e) => {
                        if (e.id === 1) {
                            getListaAll();
                            modalDownload.open();
                        }
                    }}></DropDown>
                </div>
            </div>
        )
    }
    const head = [
        { title: 'IDPayrollFactor', property: 'IDPayrollFactor', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Clase Factor', property: 'ValueTypeName', visible: true },
        { title: 'Tipo Factor', property: 'FortnightTypeName', visible: true },
        { title: 'ID Exógena', property: 'IDInfoForTaxReporting', visible: true },
        { title: 'Hoja Exógena', property: 'InfoForTaxReportingSheetName', visible: true },
        { title: 'Columna Exógena', property: 'InfoForTaxReportingColumnName', visible: true },
        { title: 'ID Nómina Electrónica', property: 'IDElectronicPayroll', visible: true },
        { title: 'Concepto Nómina Electrónica', property: 'ElectronicPayrollSheetName', visible: true },
        { title: 'Propiedad Nómina Electrónica', property: 'ElectronicPayrollColumnName', visible: true },
        { title: 'ID Concepto Certificado Ingresos y Retenciones', property: 'IDInfoForTaxCertificate', visible: true },
        { title: 'Hoja Concepto de Ingresos y Retenciones', property: 'InfoForTaxCertificateSheetName', visible: true },
        { title: 'Columna Concepto Ingresos y Retenciones', property: 'InfoForTaxCertificateColumnName', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Definir Concepto de Certificado de Ingreso', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModaldefinir({ ...modaldefinir, "view": true }) } },
            { titulo: 'Definir Concepto de Nómina Electrónica', icono: 'ri-edit-2-line', visible: single.canDelete(), evento: () => { setModaldef({ ...modaldef, "view": true }) } },
            { titulo: 'Definir Concepto de Información Exógena', icono: 'ri-edit-2-line', visible: single.canDelete(), evento: () => { setModalexo({ ...modalexo, "view": true }) } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (


        <div className="row">
            <div className="col-md-6">
                <AccountantYear idSelector={Year} onChange={(e) => { setYear(e) }} />
            </div>
            <div className="col-md-6">
                <label>Búsqueda por Texto</label>
                <input type="text" className="form-control" value={regexStr} onChange={(e) => { setregexStr(e.target.value) }} />
            </div>
            <div className="col-md-6 mt-4 p-2">
                <BasicButton icon="ri-align-justify" eventClick={getLista}>Buscar</BasicButton>
            </div>
            <div className="col-md-12">
                <BasicTable headButtons={buttons()} body={lista} head={head} rowSet={factor.setBean} listButtons={listaBotones()} pageTop={paginador.page} next={paginador.next} back={paginador.back} records={paginador} customRows={15}></BasicTable>
                <Modal modal={modaldefinir} updateModal={setModaldefinir} eventModal={addAnnuallyPayrollFactor}>
                    <div className="row">
                        <div className="col-md-12">
                            <InfoForTaxCertificateEditor yearid={Year} render={Annually.bean.TaxCertificateName} idSelector={Annually.bean.IDInfoForTaxCertificate} onChange={(e) => { Annually.setBean({ ...Annually.bean, "IDInfoForTaxCertificate": e.IDInfoForTaxCertificate, "TaxCertificateName": e.SheetName }) }} returnType="Object" />
                        </div>
                    </div>
                </Modal>
                <Modal modal={modaldef} updateModal={setModaldef} eventModal={setElectronicPayrollToPayrollFactor}>
                    <div className="row">
                        {/* <div className="col-md-12">
                            <ElectronicPayrollCatalogSelect idSelector={payroll.bean.IDElectronicPayroll} onChange={(e) => { payroll.setBean({ ...payroll.bean, "IDElectronicPayroll": e }) }} />
                        </div> */}
                        <div className="col-md-12">
                            <ElectronicPayrollEditor render={payroll.bean.ElectronicPayrollName} idSelector={payroll.bean.IDElectronicPayroll} onChange={(e) => { payroll.setBean({ ...payroll.bean, "IDElectronicPayroll": e.IDElectronicPayroll, "ElectronicPayrollName": e.PropertyName }) }} returnType="Object" />
                        </div>
                    </div>
                </Modal>
                <Modal modal={modalexo} updateModal={setModalexo} eventModal={setInfoForTaxReportingToPayrollFactor}>
                    <div className="row">
                        <InfoForTaxReportingCatalogSelect idSelector={TaxReporting.bean.IDInfoForTaxReporting} onChange={(e) => { TaxReporting.setBean({ ...TaxReporting.bean, "IDInfoForTaxReporting": e }) }} />
                    </div>
                </Modal>
                <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                    <strong>Eliminar item {factor.bean.Name}</strong>
                </ModalConfirm>
                <Modal modal={modalDownload.modal} updateModal={modalDownload.setModal}>
                    <div className="row">
                        <div className="col-md-12">
                            {listaAll.length > 0 &&
                                <ExportXLSL customName={'Descarga'} optionIcon="ri-download-cloud-2-line text-success" title={head} data={listaAll} onExport={(name: string) => {
                                    _single.download("formato xlsx [" + name + "] con " + lista.length + " registros");
                                }} />
                            }
                        </div>
                    </div>
                </Modal>
            </div>

        </div>

    )
}